import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import TimeUtils from 'app/common/util/TimeUtils';
import { HotspotDto, TimePeriod } from 'app/model/CORE';

interface HotspotBarProps {
    barHeight: number;
    hotspot: HotspotDto;
    monitoredPeriod: TimePeriod;
}

export class HotspotBar extends PureComponent<HotspotBarProps> {
    private svgRef = React.createRef<SVGSVGElement>();

    render() {
        if (!this.props.hotspot || !this.props.monitoredPeriod) return null;

        const heightEm = `${this.props.barHeight}em`;
        return (
            <Flex size={heightEm}>
                <svg ref={this.svgRef} height={heightEm} style={{ width: '100%', shapeRendering: 'crispEdges' }}>
                    {this.renderActivationBottomLine()}
                </svg>
            </Flex>
        );
    }

    renderActivationBottomLine = () => {
        // Draw a solid line for hotspot period
        const heightEm = `${this.props.barHeight / 2}em`;
        const tickMargin = 0.2 * this.props.barHeight;

        const x = this.getX();
        const width = this.getWidth();

        return [
            <line
                key={'tick-1'}
                x1={x.toFixed(5) + '%'}
                y1={`${tickMargin}em`}
                x2={x.toFixed(5) + '%'}
                y2={`${this.props.barHeight - tickMargin}em`}
                stroke="#FFFFFF"
                strokeWidth={'0.05em'}
                shapeRendering="geometricPrecision"
            />,
            <line
                key={'hotspot-period'}
                x1={x.toFixed(5) + '%'}
                y1={heightEm}
                x2={(x + width).toFixed(5) + '%'}
                y2={heightEm}
                stroke="#FFFFFF"
                strokeWidth={'0.05em'}
                shapeRendering="geometricPrecision"
            />,
            <line
                key={'tick-2'}
                x1={(x + width).toFixed(5) + '%'}
                y1={`${tickMargin}em`}
                x2={(x + width).toFixed(5) + '%'}
                y2={`${this.props.barHeight - tickMargin}em`}
                stroke="#FFFFFF"
                strokeWidth={'0.05em'}
                shapeRendering="geometricPrecision"
            />,
        ];
    };

    private getWidth = () => {
        const monitoredPeriod = this.props.monitoredPeriod;
        const timePeriod = this.props.hotspot.hotspotId.timePeriod;
        return (
            (100 * TimeUtils.diffInMs(timePeriod.to.getTime(), timePeriod.from.getTime())) /
            TimeUtils.diffInMs(monitoredPeriod.to.getTime(), monitoredPeriod.from.getTime())
        );
    };

    private getX = () => {
        const monitoredPeriod = this.props.monitoredPeriod;
        const timePeriod = this.props.hotspot.hotspotId.timePeriod;
        return (
            (100 * TimeUtils.diffInMs(timePeriod.from.getTime(), monitoredPeriod.from.getTime())) /
            TimeUtils.diffInMs(monitoredPeriod.to.getTime(), monitoredPeriod.from.getTime())
        );
    };
}
